import { makeAutoObservable } from 'mobx'
import { BiFilterAlt } from 'react-icons/bi'

import { Button } from '@/Core/UI/Button'

import type { ReactNode } from 'react'

/**
 * Стан панелі фільтрів списку у вкладці картки.
 *
 * Ядровий `crudContext.isFilterOpen` — одне налаштування користувача на ВСІ
 * списки: панель, відкрита в реєстрі, відкривалася б у кожній картці й
 * забирала 280 px над трьома рядками, а закрита в картці — зникала б і в
 * реєстрі. Тому вкладка тримає стан сама: за замовчуванням панель згорнута,
 * над таблицею лишаються рядок статусів і лійка.
 *
 * Підключення — у конфігу вкладеного контексту: екземпляр у
 * `storages.filterPanel` і `PushLocalFilterButtonToTitleExtra` на місці
 * ядрового обробника лійки. Решту робить `CrudResourceTemplate`.
 */
export class LocalFilterPanel {
    isOpen = false

    constructor() {
        makeAutoObservable(this)
    }

    toggle(): void {
        this.isOpen = !this.isOpen
    }

    close(): void {
        this.isOpen = false
    }
}

interface HeaderPageContextLike {
    titleExtra?: ReactNode[]
    storages?: { crudContext?: { storages?: { filterPanel?: LocalFilterPanel } } }
}

/**
 * Лійка вкладеного списку — той самий вигляд, що в ядрі
 * (`PushFilterButtonToTitleExtra`), але перемикає стан вкладки, а не
 * налаштування користувача.
 */
export const PushLocalFilterButtonToTitleExtra = ({ headerPageContext }: { headerPageContext?: HeaderPageContextLike }) => {
    const panel = headerPageContext?.storages?.crudContext?.storages?.filterPanel

    if (!headerPageContext || !panel) return

    headerPageContext.titleExtra ??= []
    headerPageContext.titleExtra.push(
        <Button
            key="crudresource-filterbutton-headerpage-local"
            type="link"
            onClick={() => panel.toggle()}
            icon={<BiFilterAlt style={{ fontSize: 24 }} />}
        />
    )
}
